/* ── Global Glow Effect JS ──
   Looks for all containers with class="glow-enabled"
   and a child [data-glow]. Adds mouse-follow with lerp.
*/
(function () {
  var containers = document.querySelectorAll('.glow-enabled');
  if (!containers.length) return;

  containers.forEach(function (root) {
    var glow = root.querySelector('[data-glow]');
    if (!glow) return;

    var glowX = 0, glowY = 0, targetX = 0, targetY = 0;
    var raf = null;

    function tick() {
      glowX += (targetX - glowX) * 0.08;
      glowY += (targetY - glowY) * 0.08;
      glow.style.left = glowX + 'px';
      glow.style.top  = glowY + 'px';
      raf = requestAnimationFrame(tick);
    }

    root.addEventListener('mouseenter', function () {
      if (!raf) raf = requestAnimationFrame(tick);
    });

    root.addEventListener('mouseleave', function () {
      if (raf) { cancelAnimationFrame(raf); raf = null; }
    });

    root.addEventListener('mousemove', function (e) {
      var rect = root.getBoundingClientRect();
      targetX = e.clientX - rect.left;
      targetY = e.clientY - rect.top;
    });
  });
})();
